import { render, staticRenderFns } from "./FilterGame.vue?vue&type=template&id=064e0082"
import script from "./FilterGame.vue?vue&type=script&lang=js"
export * from "./FilterGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports